import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { AlertTriangle, ArrowRight } from "lucide-react";

export function useDuplicateGuard() {
  const [dup, setDup] = useState(null);
  const guard = async (name, excludeId, proceed) => {
    let matches = [];
    try { matches = (await api.get("/customers/check-duplicate", { params: { name, exclude_id: excludeId || "" } })).data || []; } catch { matches = []; }
    if (matches.length) { setDup({ matches, proceed }); return; }
    await proceed();
  };
  return { dup, setDup, guard };
}

export function DuplicateCustomerDialog({ dup, setDup, onOpenExisting, openLabel = "Otvoriť existujúceho" }) {
  const close = () => setDup(null);
  const [pick, setPick] = useState(null);
  const first = (dup?.matches || []).find((c) => c.id === pick) || dup?.matches?.[0];
  return (
    <Dialog open={!!dup} onOpenChange={(o) => { if (!o) { close(); } }}>
      <DialogContent className="sm:max-w-md" data-testid="duplicate-customer-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2 font-heading uppercase"><AlertTriangle className="h-5 w-5 text-amber-400" /> Zákazník už existuje</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Zákazník s rovnakým menom je už uložený:</p>
        <div className="space-y-2">
          {(dup?.matches || []).map((c) => (
            <button type="button" key={c.id} onClick={() => setPick(c.id)} className={`w-full rounded-lg border p-3 text-left text-sm transition-colors ${first?.id === c.id ? "border-primary bg-primary/10" : "border-border bg-card hover:border-primary/50"}`} data-testid={`duplicate-customer-${c.id}`}>
              <div className="font-semibold">{c.name}</div>
              <div className="text-xs text-muted-foreground">{[c.city, c.phone, c.ico && `IČO ${c.ico}`].filter(Boolean).join(" · ") || "bez ďalších údajov"}</div>
            </button>
          ))}
        </div>
        <DialogFooter className="flex-col gap-2 sm:flex-col sm:space-x-0">
          <Button className="w-full gap-2" onClick={() => { close(); onOpenExisting(first); }} data-testid="duplicate-open-existing">{openLabel} <ArrowRight className="h-4 w-4" /></Button>
          <Button variant="secondary" className="w-full" onClick={() => { const p = dup.proceed; close(); p(); }} data-testid="duplicate-save-anyway">Aj tak uložiť nového</Button>
          <Button variant="ghost" className="w-full" onClick={close} data-testid="duplicate-back">Späť na úpravu</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
